<template>
  <v-container fluid class="background">
    <v-container class="py-10">
      <v-row>
        <v-col sm="6" cols="12">
          <iframe
            width="100%"
            height="250"
            frameborder="0"
            style="border:0"
            src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBxU5067PcOlTHAV0AY9DDWoWkpQsgdZtI&q=R.+19+1257,+4500-252+Espinho&zoom=15"
            allowfullscreen
          />
        </v-col>
        <v-col sm="6" cols="12">
          <div class="contacts_title mb-5">
            {{ contacts.title }}
          </div>
          <div class="my-auto pointer" @click="openMap(contacts.address.maps)">
            <v-icon size="16" class="contacts_text mr-1">
              mdi-map-marker-outline
            </v-icon>
            <span class="contacts_text mr-5 my-auto">{{
              contacts.address.address
            }}</span>
          </div>
          <div
            v-for="email in contacts.email"
            :key="email"
            class="my-auto pointer"
            @click="sendEmail(email)"
          >
            <v-icon size="16" class="contacts_text mr-1">
              mdi-at
            </v-icon>
            <span class="contacts_text mr-5 my-auto">{{ email }}</span>
          </div>
          <div v-for="phone in contacts.phone" :key="phone">
            <a :href="'tel:' + phone" class="my-auto link">
              <v-icon size="16" class="contacts_text mr-1">
                mdi-phone-outline
              </v-icon>
              <span class="contacts_text mr-5 my-auto">{{ phone }}</span>
            </a>
          </div>
          <div v-for="mobile in contacts.mobile" :key="mobile + '_mob'">
            <a :href="'tel:' + mobile" class="my-auto link">
              <v-icon size="16" class="contacts_text mr-1">
                mdi-cellphone
              </v-icon>
              <span class="contacts_text mr-5 my-auto">{{ mobile }}</span>
            </a>
          </div>
          <div v-for="wpp in contacts.wpp" :key="wpp + '_wpp'">
            <a :href="'tel:' + wpp" class="my-auto link">
              <v-icon size="16" class="contacts_text mr-1">
                mdi-whatsapp
              </v-icon>
              <span class="contacts_text mr-5 my-auto">{{ wpp }}</span>
            </a>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import lang from "../../lang/pt.json";

export default {
  name: "Contacts",

  data: () => ({
    contacts: lang.home.contacts,
  }),

  methods: {
    openMap(map) {
      window.open(map, "_blank");
    },
    sendEmail(email) {
      window.open(`mailto:${email}`, "emailWindow");
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/scss/variables.scss";

.background {
  background: map-get($theme-colors, "backgroundpartnership");
}

.contacts_title {
  color: white;
  font-family: nexa_bold;
  font-size: 24px;
  letter-spacing: 0;
  line-height: 24px;
}

.contacts_text {
  color: white;
  font-family: "Roboto" !important;
  font-size: 15px;
  letter-spacing: 0;
  line-height: 24px;
}

.pointer {
  cursor: pointer;
}

.link {
  text-decoration: none;
}
</style>
